var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPassword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .password-class-a {\n                fill: #fff;\n                fill-rule: evenodd;\n            }\n\n            .password-class-b {\n                fill: none !important;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "password-class-a",
    d: "M5811.573-3175.172a6.281,6.281,0,0,0-6.282-6.281,6.28,6.28,0,0,0-6.281,6.281v4.188h-1.046a2.093,2.093,0,0,0-2.095,2.094v10.469a2.093,2.093,0,0,0,2.095,2.094h14.655a2.093,2.093,0,0,0,2.095-2.094v-10.469a2.093,2.093,0,0,0-2.095-2.094h-1.046Zm-10.469,0v4.188h8.374v-4.188a4.187,4.187,0,0,0-3.976-4.183l-.211-.005a4.19,4.19,0,0,0-4.184,3.979Zm-3.141,6.282h14.655v10.469h-14.655Zm9.423,5.235a2.1,2.1,0,0,1-2.1,2.094,2.1,2.1,0,0,1-2.1-2.094,2.1,2.1,0,0,1,2.1-2.094A2.1,2.1,0,0,1,5807.387-3163.656Z",
    transform: "translate(-5788.869 3184.454)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "password-class-b",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_password.1025174935095fa5a10cc40a8cab7736.svg";